import {
  GET_ALL_ORDERS,
  GET_ALL_TRIPS,
  DELETE_ONE_TRIP,
  GET_ONE_TRIP,
  GET_ONE_DEMO_TRIP,
  SAVE_TRIP
} from '../../actionTypes';
import {
  SUCCESS,
  CONTINUE
} from '../../../utils/status';

// 分支
const reducerBranch = {
  [SAVE_TRIP](state, action) {
    let nextState;

    if (action.status === SUCCESS) {
      let trip = action.data;
      nextState = {...state};
      nextState[trip.trip_id] = {...nextState[trip.trip_id], ...trip};
    } else {
      nextState = state;
    }

    return nextState;
  },
  [GET_ALL_ORDERS](state, action) {
    let nextState;

    if (action.status === SUCCESS) {
      nextState = {...state};
      let trips = action.data.trips;
      trips.forEach(function (trip) {
        nextState[trip.trip_id] = {...nextState[trip.trip_id], ...trip};
      });
    } else {
      nextState = state;
    }

    return nextState;
  },


  [GET_ALL_TRIPS](state, action) {
    let nextState;

    if (action.status === SUCCESS || action.status === CONTINUE) {
      nextState = {...state};
      let trips = action.data.list;
      trips.forEach(function (trip) {
        nextState[trip.trip_id] = {...nextState[trip.trip_id], ...trip};
      });
    } else {
      nextState = state;
    }

    return nextState;
  },


  [DELETE_ONE_TRIP](state, action) {
    let nextState;

    if (action.status === SUCCESS) {
      nextState = {...state};
      delete nextState[action.data];
    } else {
      nextState = state;
    }

    return nextState;
  },

  [GET_ONE_TRIP](state, action) {
    let nextState;

    if (action.status === SUCCESS) {
      let trip = action.data;
      nextState = {...state};
      nextState[trip.trip_id] = {...nextState[trip.trip_id], ...trip};
    } else {
      nextState = state;
    }

    return nextState;
  },

  [GET_ONE_DEMO_TRIP](state, action) {
    let nextState;

    if (action.status === SUCCESS) {
      let trip = action.data;
      nextState = {...state};
      nextState[trip.trip_id] = {...nextState[trip.trip_id], ...trip};
    } else {
      nextState = state;
    }

    return nextState;
  }
};

export default function reducer(state = {}, action) {
  let nextState;
  let branch = reducerBranch[action.type];

  if (branch) {
    nextState = branch(state, action);
  } else {
    nextState = state;
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./src/store/reducers/entity/trip.js